var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Getting Started")]),_vm._v(" "),_c('p',[_vm._v("Contact to Luffanet first. "),_c('a',{attrs:{"href":"https://luffanet.freshdesk.com/support/home"}},[_vm._v("Click here to support center.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08655207","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/getting_started.vue
// module id = null
// module chunks = 